import { showMessage } from './message';

/**
 * 公共方法：检查后端响应的status状态
 * @param {Object} response - 后端响应数据
 * @returns {Object} - 返回响应数据或抛出错误
 */
export const checkStatus = (response) => {
  if (!response) {
    throw new Error('响应数据为空');
  }

  // status 为 0 表示业务请求成功
  if (response.status === 0) {
    return response;
  }

  // status 不等于 0 表示业务请求失败，不在这里显示错误消息
  // 让调用方决定如何处理错误消息
  if (response.status !== 0) {
    const errorMessage = response.message || '请求失败';
    
    // 创建一个包含业务错误信息的错误对象
    const error = new Error(errorMessage);
    error.status = response.status;
    error.response = response;
    error.isBusinessError = true; // 标记为业务错误
    throw error;
  }

  return response;
};

/**
 * 处理API响应的通用方法
 * @param {Promise} apiCall - API调用的Promise
 * @returns {Promise} - 处理后的Promise
 */
export const handleApiResponse = async (apiCall) => {
  try {
    const response = await apiCall;
    return checkStatus(response);
  } catch (error) {
    // 如果是网络错误或其他非业务错误
    if (!error.response) {
      showMessage('网络连接失败，请检查网络设置', 'error');
    }
    throw error;
  }
};

/**
 * 格式化错误消息
 * @param {Error} error - 错误对象
 * @returns {string} - 格式化后的错误消息
 */
export const formatErrorMessage = (error) => {
  if (error.response && error.response.message) {
    return error.response.message;
  }
  
  if (error.message) {
    return error.message;
  }
  
  return '未知错误';
};